import SuperAdminRoutes from "../../../apiRoutes/SuperAdminRoutes";
import { api } from "../../ConsumeApiController";

export async function listPlans()
{
    try {
        const response = await api.get(SuperAdminRoutes.Subscriptions.Plans.List);

        if (response.success) {
            // Desestructuramos y retornamos directamente
            const { kpis, recent_activity, plans } = response.data;
            return { kpis, recent_activity, plans };
        }

        // Si la API responde con success: false (ej. validación fallida),
        // devolvemos valores por defecto seguros (stats es un objeto, no un array).
        return { kpis: {}, recent_activity: [], plans: [] };

    } catch (error) {
        // Si hay un error de red o el servidor devuelve un 500
        console.error("Error al obtener los detalles de la promoción:", error);
        
        // Retornamos la misma estructura vacía para que la UI no se rompa
        return { kpis: {}, recent_activity: [], plans: [] };
    } 
}


export async function createPlan(
    name, code, description,
    price, billing_interval, interval_count,
    trial_days,
    status
){
    const response = await api.post(SuperAdminRoutes.Subscriptions.Plans.Store,{
        name,
        code,
        description,
        price,
        billing_interval,
        interval_count,
        trial_days,
        status
    });
    return response;
}




